import React from 'react';
import classnames from 'classnames';
import OrderTotalSummaryBase from '../../../components/OrderTotalsSummary';

import CheckoutGuaranties from '../CheckoutGuaranties';
import styles from './OrderTotalSummary.module.scss';

const OrderTotalSummary = ({
  isDraftOrder = false,
  isSteppedCheckout = false,
}: {
  isDraftOrder: boolean;
  isSteppedCheckout: boolean;
}) => (
  <OrderTotalSummaryBase
    isPromoSectionDisabled={isDraftOrder}
    isSteppedCheckout={isSteppedCheckout}
    showPayAsLow
    isDraftOrder
  >
    <div
      className={classnames(
        styles['hidden-on-mobile'],
        styles['checkout-guaranties-container'],
      )}
    >
      <CheckoutGuaranties />
    </div>
  </OrderTotalSummaryBase>
);

export default OrderTotalSummary;
